import uniqBy from 'lodash/uniqBy';

import { EExpandShopItems, EShopCategory, getShopItems } from '~/src/api/content/shop/getShopItems';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import { ESubscriptionsDomruTvActions } from '../reducers';

export const fetchSubscriptionItems = () => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState) => {
        const { city: { provider: { providerId } } } = getState();

        const resp = await getShopItems(providerId, null, `${EShopCategory.Subscriptions}`, [EExpandShopItems.Advertising], null, true);
        const subscriptions = resp?.sort((a, b) => b.category_id - a.category_id);

        dispatch({
            type: ESubscriptionsDomruTvActions.FETCH_SUBSCRIPTIONS,
            payload: {
                items: uniqBy(subscriptions, 'alias'),
            },
        });
    };
};
